import { Box, Flex } from "@chakra-ui/react";
import React from "react";
import { Link as ReactRouterLink } from "react-router-dom";
import { Link as ChakraLink, LinkProps } from "@chakra-ui/react";
import { HashLink } from "react-router-hash-link";


export default function Navbar() {
  return (
    <Box
      position={"fixed"}
      zIndex={"sticky"}
      right={{ base: "auto", lg: "0" }}
      mx={{ base: "10vw", lg: 0 }}
      p="0"
    >
      <Flex
        justifyContent={"space-between"}
        alignItems={"center"}
        px={{ base: 10, lg: 20 }}
        h={"4vh"}
        w={{ base: "80vw", lg: "50vw" }}
        borderLeftRadius="3rem"
        borderRightRadius={{ base: "3rem", lg: "0rem" }}
        m={0}
        my="1rem"
        background="offwhiteOpacity"
        backdropFilter="blur(5px)"
        border="lightgrey solid 1px"
        borderRightColor={{ base: "lightgrey", lg: "transparent" }}
      >
        <Flex>
          <HashLink smooth to="/#top">
            <ChakraLink variant={"navLink"} px="0">
              HOME
            </ChakraLink>
          </HashLink>
        </Flex>
        <Flex>
          <HashLink smooth to="/#work">
            <ChakraLink variant={"navLink"} pr="0">
              PORTFOLIO
            </ChakraLink>
          </HashLink>
          <HashLink smooth to="/#resume">
            <ChakraLink variant={"navLink"} pr="0">
              RESUME
            </ChakraLink>
          </HashLink>
          <HashLink smooth to="/#about">
            <ChakraLink variant={"navLink"} pr="0">
              ABOUT ME
            </ChakraLink>
          </HashLink>
          <HashLink smooth to="/#contact">
            <ChakraLink variant={"navLink"} pr="0">
              CONTACT
            </ChakraLink>
          </HashLink>
        </Flex>
      </Flex>
    </Box>
  );
}
